module.exports = {"411624001":"东城街道","411624002":"北城街道","411624100":"槐店回族镇","411624101":"刘庄店镇","411624102":"留福集镇","411624103":"老城镇","411624104":"赵德营镇","411624105":"付井镇","411624106":"纸店镇","411624107":"新安集镇","411624108":"白集镇","411624109":"刘湾镇","411624110":"莲池镇","411624111":"洪山镇","411624112":"北杨集镇","411624113":"邢庄镇","411624114":"周营镇","411624201":"石槽集乡","411624202":"范营乡","411624203":"李老庄乡","411624205":"冯营乡","411624209":"卞路口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411624.json
// module id = 1802
// module chunks = 0